A download URL for the attachment.

This URL accepts partner tokens or browser tokens that include the `download:candidate-profile-attachments` scope.
This is guaranteed to be an absolute URL with an origin of `https://graphql.seek.com`.
